import React, { type ReactElement, type ReactNode } from 'react';
import { useDispatch } from 'react-redux';
import { Badge, Icon, TabGroup, TabItem } from '@saviynt/design-system';

import { SodHeader, SodStatusChip } from '../../../shared/components';
import { detailsActions } from '../data-store/detailsSlice';

import './DetailsHeader.css';

interface DetailsHeaderProps {
  params: {
    title: string;
    description: ReactNode | string | null;
    tabInAction?: string | null;
    breadcrumbItems?: {
      text: string;
      href: string;
    }[];
  };
  tabOptions: {
    label: string;
    value: string;
    icon: string;
    badgeCount?: number;
  }[];
  activeTab: string;
  setActiveTab: (value: string) => void;
  handleBackButton: () => void;
}

/**
 * DetailsHeader
 */
function DetailsHeader({
  params,
  tabOptions,
  activeTab,
  setActiveTab,
  handleBackButton,
}: DetailsHeaderProps): ReactElement {
  const dispatch = useDispatch();

  const handleChange = (value: string) => {
    dispatch(detailsActions.setSidePanelClose());
    setActiveTab(value);
  };

  return (
    <SodHeader
      title={params.title}
      description={params.description}
      controls={
        <SodStatusChip
          kind='medium'
          tabInAction={params.tabInAction ?? ''}
          className='Sod-DetailsHeader-headerChip'
        />
      }
      contentBottom={
        <TabGroup
          value={activeTab}
          onChange={handleChange}
          className='Sod-DetailsHeader-tabGroup'>
          {tabOptions.map((tab) => (
            <TabItem
              key={tab.value}
              label={tab.label}
              value={tab.value}
              icon={<Icon kind={tab.icon} size='medium' />}
              BadgeComp={
                tab.badgeCount ? (
                  <Badge
                    kind='number'
                    size='medium'
                    badgeStyle='outlined'
                    number={tab.badgeCount}
                    color='info'
                  />
                ) : undefined
              }
            />
          ))}
        </TabGroup>
      }
      handleGoBack={handleBackButton}
      applicationIconKind='SOD'
      className='Sod-DetailsHeader'
      breadcrumbItems={params.breadcrumbItems}
    />
  );
}

export default DetailsHeader;
